import { getMeta } from 'lambda-dom'

export const articleId = getMeta('article-id', parseInt)!

// ------------------------------------------------------------------------------
//      Elements
// ------------------------------------------------------------------------------

export const counter = document.getElementById('clap-counter')!

export const grid = document.getElementById('relevant-grid')
